import LTR from "@brand-icons/global/time/time-ltr.svg";

import { iconFactory } from "../iconFactory";

export const TimeIcon = iconFactory("TimeIcon", LTR);
